 document.addEventListener('DOMContentLoaded', function () {
    const toc = document.querySelector('ul.toc-navigation');
    if (!toc) return;
  
    // Klikgedrag
    toc.addEventListener('click', function (e) {
      const clickedLink = e.target.closest('a');
      if (!clickedLink) return;
  
      const parentLi = clickedLink.closest('li');
      if (!parentLi) return;
  
      const submenu = parentLi.querySelector(':scope > ul');
  
      if (submenu) {
        e.preventDefault();
  
        const isOpen = submenu.classList.contains('force-open');
  
        submenu.classList.toggle('is-open', !isOpen);
        clickedLink.classList.toggle('open', !isOpen);
  
        if (isOpen) {
          submenu.classList.remove('force-open');
        } else {
          submenu.classList.add('force-open');
        }
  
        return;
      }
  
      // Submenu-link geklikt
      const containingUl = parentLi.closest('ul');
      if (containingUl && !containingUl.classList.contains('toc-navigation')) {
        const topLi = containingUl.closest('li');
        const triggerLink = topLi.querySelector('a');
        containingUl.classList.remove('is-open', 'force-open');
        if (triggerLink) triggerLink.classList.remove('open');
      }
    });
  
    // Hovergedrag
    toc.querySelectorAll('li').forEach(li => {
      const link = li.querySelector(':scope > a');
      const submenu = li.querySelector(':scope > ul');
  
      if (link && submenu) {
        li.addEventListener('mouseenter', () => {
          if (submenu.classList.contains('force-open')) return;
          submenu.classList.add('is-open');
          link.classList.add('open');
        });
  
        li.addEventListener('mouseleave', () => {
          if (submenu.classList.contains('force-open')) return;
          submenu.classList.remove('is-open');
          link.classList.remove('open');
        });
      }
    });
  });
  